import { Search } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { DateRangePicker } from '@/components/ui/date-range-picker'
import type { DateRangeValue } from '@/components/ui/date-range-picker'
import { FilterFormWrapper } from '@/components/FilterFormWrapper'
import { Select } from '@/components/ui/select'

export interface VersionFilterValues {
  versionName: string
  time: DateRangeValue | undefined
  status: number | undefined
}

interface VersionFilterPanelProps {
  values: VersionFilterValues
  onChange: (values: VersionFilterValues) => void
  onSearch: () => void
}

export function VersionFilterPanel({
  values,
  onChange,
  onSearch,
}: VersionFilterPanelProps) {
  function set<TKey extends keyof VersionFilterValues>(
    key: TKey,
    value: VersionFilterValues[TKey],
  ) {
    onChange({ ...values, [key]: value })
  }

  return (
    <FilterFormWrapper
      onSearch={onSearch}
      className="rounded-xl border border-gray-100 bg-white px-6 py-5"
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-end gap-4">
          <div className="flex min-w-[200px] flex-1 flex-col gap-2">
            <span className="text-sm font-medium">Tên phiên bản</span>
            <Input
              placeholder="Nhập từ khóa"
              value={values.versionName}
              onChange={(e: { target: { value: string } }) =>
                set('versionName', e.target.value)
              }
            />
          </div>
          <div className="flex min-w-[200px] flex-1 flex-col gap-1">
            <span className="text-sm font-medium">Trạng thái</span>
            <Select
              placeholder="Tất cả"
              value={values.status}
              className="w-full"
              onValueChange={(v) => set('status', v)}
              allowClear
              options={[
                { value: 1, label: 'Hoạt động' },
                { value: 0, label: 'Không hoạt động' },
              ]}
            />
          </div>
          <div className="flex min-w-[200px] flex-1 flex-col gap-1">
            <span className="text-sm font-medium">Thời gian</span>
            <DateRangePicker
              value={values.time}
              onChange={(v) => set('time', v)}
              className="w-full"
            />
          </div>
          <Button
            variant="outline"
            size="md"
            className="shrink-0 gap-2 border-[#D9704A] text-[#D9704A] hover:bg-[#D9704A]/10 rounded-full px-6"
            onClick={onSearch}
          >
            <Search size={16} />
            Tìm kiếm
          </Button>
        </div>
      </div>
    </FilterFormWrapper>
  )
}
